// this file is a bit of a hack to fix a circular dependency - ideally we reactor this over time, it used to live in keyword_engine

// KeywordScout search types.
// Used to adjust page layout based on the text, single ASIN or multiple ASINs submitted in search input.
export const KEYWORD_ENGINE_SEARCH_TYPES = {
  keyword: 'keyword',
  singleAsin: 'singleAsin',
  multipleAsins: 'multipleAsins'
}
